import React, { useEffect, useState } from "react"
import { injectIntl, defineMessages, FormattedMessage } from "react-intl"
import EcommerceConfiguration from "../../../state/ecommerce-configuration/EcommerceConfigurationValues"
import EcommerceRuleComponent from "../components/EcommerceRuleComponent"
import { Intl } from "../../../state/helpers/IntlProps"
import {
    EcommerceRule,
    EcommerceRulesSet,
    ECOMMERCE_RULE_KEY,
    ECOMMERCE_RULE_TYPE
} from "../../../state/ecommerce-configuration/EcommerceRule"
import Toggle from "react-toggle"
import {
    FEATURE_TITLE_MESSAGES,
    FEATURE_DESCRIPTION_MESSAGES,
} from "../../../state/ecommerce-configuration/messages/EcommerceRuleMessages"
import UseShowAdvancedToggle from "../../../common/hooks/UseShowAdvancedToggle"

type Props = {
    intl: Intl,
    configuration?: EcommerceConfiguration,
    onChangeCallback: (updatedRulesSet: EcommerceRulesSet) => void,
}

const messages = defineMessages({
    "cssSelectors": {
        id: "ecommerce.rules_engine.css_selectors_placeholder",
        defaultMessage: "Specify the CSS classes/ids of the elements that should be hidden/visible",
    },
})

const EcommerceConfigurationRulesEngineContainer = (props: Props) => {

    const [rulesSet, setRulesSet] = useState<EcommerceRulesSet>({
        showAddToQuoteRules: { rules: [], cssSelectors: "", enabled: false },
        hidePricesRules: { rules: [], cssSelectors: "", enabled: false },
        hideAddToCartButtonRules: { rules: [], cssSelectors: "", enabled: false },
    })

    useEffect(() => {
        if (props.configuration?.getRulesMapping()) {
            setRulesSet(props.configuration.getRulesMapping())
        }
    }, [])

    useEffect(() => {
        props.onChangeCallback(rulesSet)
    }, [rulesSet])

    return (
        <div>
            {
                Object.keys(rulesSet).map((feature, index) => {
                    const { toggleContent, toggleCurrent } = UseShowAdvancedToggle()

                    return <div key={index} className="border p-4 mb-4">

                        <h4 className="mb-2 pl-3">
                            {props.intl.formatMessage(FEATURE_TITLE_MESSAGES[feature])}
                        </h4>
                        <h6 className="mb-4 pl-3">
                            <small className="form-text text-muted">
                                {props.intl.formatMessage(FEATURE_DESCRIPTION_MESSAGES[feature])}
                            </small>
                        </h6>

                        <div className="d-flex">
                            <div className="col-md-1 col-sm-2 d-flex align-items-center">
                                <Toggle
                                    checked={rulesSet[feature].enabled}
                                    icons={false}
                                    onChange={() => {
                                        const set = rulesSet[feature]
                                        set.enabled = !set.enabled

                                        setRulesSet(prevState => ({
                                            ...prevState,
                                            [feature]: set
                                        }))
                                    }}
                                />
                            </div>
                            <div className="col-md-11 col-sm-10">
                                <label className="mb-0">
                                    <FormattedMessage
                                        id="ecommerce.rules_engine.enable_feature"
                                        defaultMessage="Enable feature"
                                    />
                                </label>
                            </div>
                        </div>

                        {
                            rulesSet[feature].enabled &&
                            <>
                                {toggleCurrent &&
                                    <div className="mt-3 mb-4">
                                        <div className="col-12">
                                            <label className="">
                                                <FormattedMessage
                                                    id="ecommerce.rules_engine.css_selectors"
                                                    defaultMessage="CSS selectors (optional)"
                                                />
                                            </label>
                                            <input
                                                name="cssSelectors"
                                                placeholder={props.intl.formatMessage(messages["cssSelectors"])}
                                                value={rulesSet[feature].cssSelectors}
                                                onChange={(e) => {
                                                    const set = rulesSet[feature]
                                                    set.cssSelectors = e.target.value

                                                    setRulesSet(prevState => ({
                                                        ...prevState,
                                                        [feature]: set
                                                    }))
                                                }}
                                                id={`${feature}-css-selectors`}
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                }
                                <div className={"text-center"}>
                                    {toggleContent}
                                </div>

                                <hr />

                                <div className="d-flex flex-wrap">
                                    {
                                        (rulesSet[feature].rules as EcommerceRule[]).map((rule, index) => {
                                            if (rule.deleted) {
                                                return <></>
                                            }

                                            return (
                                                <EcommerceRuleComponent
                                                    key={index}
                                                    rule={rule}
                                                    onUpdate={(updatedRule) => {
                                                        const set = rulesSet[feature]
                                                        set.rules[index] = updatedRule

                                                        setRulesSet(prevState => ({
                                                            ...prevState,
                                                            [feature]: set
                                                        }))
                                                    }}
                                                />
                                            )
                                        })
                                    }
                                </div>

                                <div className="d-flex justify-content-center">
                                    <button
                                        className="btn btn-primary"
                                        onClick={(e) => {
                                            e.preventDefault()

                                            const set = rulesSet[feature]
                                            set.rules.push({
                                                ruleKey: ECOMMERCE_RULE_KEY.PRODUCT_TAGS,
                                                ruleType: ECOMMERCE_RULE_TYPE.RULE_TYPE_INCLUDES_ONE_OF,
                                                enabled: true,
                                                values: [],
                                                deleted: false,
                                            })

                                            setRulesSet(prevState => ({
                                                ...prevState,
                                                [feature]: set
                                            }))
                                        }}
                                    >
                                        <FormattedMessage
                                            id="ecommerce.rules_engine.add_rule_btn"
                                            defaultMessage="Add new rule"
                                        />
                                    </button>
                                </div>
                            </>
                        }

                    </div>

                })
            }
        </div >
    )
}

export default injectIntl(EcommerceConfigurationRulesEngineContainer)



// WEBPACK FOOTER //
// ./src/settings/ecommerce/sections/EcommerceConfigurationRulesEngineContainer.tsx